import React, { Component, Fragment } from 'react';
import { Form, Button, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Loader from '../components/Global/Loader';
import Navigation from '../components/Navigation/Navigation';
import LoaderSecondary from '../components/Global/LoaderSecondary';
import { Animated } from "react-animated-css";
// import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';


export default class routeSeccions extends Component {
    

    constructor(props) {
        super(props)
        this.state = {
            clientes: null,
            producto: null,
            cursos: null,
            clienteSelected: null,
            loading: {
                productos: false,
            }
        }
        this.searchBar = this.searchBar.bind(this);
        this.obtenerClientes = this.obtenerClientes.bind(this);
        this.selecCliente = this.selecCliente.bind(this);
        this.handleSeleccion = this.handleSeleccion.bind(this);
        this.handleIdOctavio = this.handleIdOctavio.bind(this);
        this.handleGetProductos = this.handleGetProductos.bind(this);
    }
    


    componentDidMount() {
        this.obtenerClientes();
    }

    obtenerClientes() {
        if (localStorage.getItem('clientes') !== null) {
            this.setState({
                ...this.state,
                clientes: JSON.parse(localStorage.getItem('clientes'))
            })
        } else {
            let myHeaders = new Headers();
            myHeaders.append("Auth-Token", "zBKhfY9jXOUNVunScyIBltJJa3W1vg?HXsXPK5T1NCq1G!lXKN1ve9QOm25zIInZAQNgAK2VS7kTj7370NgqPg8w3DiQDb8AgtCCg6YNhU4wo45K!wEnOjPSnOtC8Rs");

            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };

            fetch(window.$UrlOctavio + "/clientes", requestOptions)
                .then(response => response.json())
                .then(result => {
                    let clientes = [];

                    for (let i = 0; i < result.length; i++) {
                        clientes.push({
                            'id': result[i].id,
                            'dominio': result[i].dominio,
                            'path_moodle': result[i].path_moodle,
                            'moodleToken': result[i].moodleToken
                        })
                    }
                    this.setState({
                        ...this.state,
                        clientes: clientes,
                    })
                })
                .catch(error => console.log('error', error));
        }
    }

    route() {
        return (
            <div className="bg-light pt-3">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <label className="navigation-breadcrumb">Inicio &gt; Secciones</label>
                            <h5>Crear secciones</h5>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    searchBar() {
        return (
            <div className="navbarstiky sticky-top bg-white mb-4 pb-3 pt-3">
                <div className="container">
                    {this.selecCliente()}
                </div>
            </div>
        )
    }

    selecCliente() {
        if (this.state.clientes) {
            if (this.state.clientes.length === null || this.state.clientes.length === undefined) {
                return <LoaderSecondary></LoaderSecondary>
            } else {
                return <Fragment>
                    <Form onSubmit={this.handleGetProductos}>
                        <Form.Row>
                            <Col>
                                <label className="m-0 mr-3" htmlFor="id_cliente">Cliente</label>
                                <select type="text" className="form-control mb-2" name="id_cliente" onChange={this.handleSeleccion}>
                                    <option value="">Selecciona el cliente</option>
                                    {this.state.clientes.map(cliente => {
                                        return <option key={`cliente${cliente.id}`} value={JSON.stringify(cliente)}>{`${cliente.id} - ${cliente.dominio}`}</option>
                                    })}
                                </select>
                            </Col>
                            <Col>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label className='mb-0'>Id de Octavio</Form.Label>
                                    <Form.Control onChange={this.handleIdOctavio} type="text" placeholder="ID Octavio del producto" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Button className='mt-3' variant="primary" type="submit">
                                    Submit
                                </Button>
                            </Col>
                        </Form.Row>
                    </Form>
                </Fragment>
            }
        } else {
            return <LoaderSecondary></LoaderSecondary>
        }
    }

    async handleSeleccion(e) {
        const { value, name } = e.target;
        switch (name) {
            case 'id_cliente':
                this.setState({
                    ...this.state,
                    clienteSelected: await JSON.parse(value),
                })
                sessionStorage.setItem('clienteSelected', value);
                break;
            default:
                this.setState({
                    ...this.state,
                    [name]: value,
                })
                break;
        }
    }

    handleIdOctavio(e) {
        const { value, name } = e.target;
        this.setState({
            ...this.state,
            producto: value,
        })
    }

    handleGetProductos() {
        const instance = axios.create({
            baseURL: 'https://capabilia.instructure.com:443/api/v1/',
            timeout: 10000,
            headers: {
                'Authorization': 'Bearer 7272~7RuLyPAd9ECAR8qkR0iVuKsqZmT09snVNkWhPp2x3YfNYsTObyFUCPJxhhUOnA4P',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                
            }
            });
        if (this.state.clienteSelected = +! null) {
            try {
                return new Promise((res, rej) => {

                    let productos = [];

                    var myHeaders = new Headers();
                    myHeaders.append("Auth-Token", "zBKhfY9jXOUNVunScyIBltJJa3W1vg?HXsXPK5T1NCq1G!lXKN1ve9QOm25zIInZAQNgAK2VS7kTj7370NgqPg8w3DiQDb8AgtCCg6YNhU4wo45K!wEnOjPSnOtC8Rs");
                    myHeaders.append("cliente", this.state.clienteSelected.id);

                    var requestOptions = {
                        method: 'GET',
                        headers: myHeaders,
                        redirect: 'follow'
                    };
                        console.log("voy a octavio");
                        
                    fetch(window.$UrlOctavio + "/productos/" + this.state.producto, requestOptions)
                        .then(response => response.json())
                        .then(async (result) => {
                            if (result.error) {
                                console.log('error', result.error)
                            }else{
                                console.log("inicio");

                                instance.get('/courses/7622/sections', {
                                    params: {
                                    }
                                })
                                .then(function (response) {
                                    console.log(response);
                                })
                                .catch(function (error) {
                                    console.log(error);
                                })
                                .finally(function () {
                                    
                                })
                            
                                }
                            })
                        
                })

            } catch (error) {
                console.log(error)
            }
        }


    }

    renderProductos() {
        if (this.state.loading.productos === true) {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Loader></Loader>
                        </div>
                    </div>
                </div>
            )
        } else {
            if (this.state.productos === null) {
                return (
                    false
                )
            } else {
                const defaultSortedBy = [{
                    dataField: "id",
                    order: "desc"
                }];
                return (
                    <Animated animationIn="slideInUp" animationOut="fadeOut" animationInDuration={380} isVisible={true}>
                        <div className="container mt-5">
                            <div className="row">
                                <div className="col-12">

                                </div>
                            </div>
                        </div>
                    </Animated>
                )
            }
        }
    }

    render() {
        return (
            <Fragment>
                <Navigation />
                {this.route()}
                {this.searchBar()}
                {this.renderProductos()}
            </Fragment>
        )
    }
}
